import apiClient from '../apiClient';
import { POST_TOP_UP_PAYMENT_GATEWAY_URL } from '../apiUrl';

const postTopUpPaymentGatewayApi = data => {
  return apiClient.post(POST_TOP_UP_PAYMENT_GATEWAY_URL, data);
};

export default postTopUpPaymentGatewayApi;
